(function () {
  function initFaqAccordion(root) {
    var items = root.querySelectorAll('[data-acc-item]');
    items.forEach(function (item) {
      var head = item.querySelector('[data-acc-head]');
      if (!head) return;
      head.addEventListener('click', function () {
        item.classList.toggle('open');
      });
    });
  }

  function initTierModal(root) {
    var modal = root.querySelector('#heathen-plus-modal');
    if (!modal) return;

    var body = document.body;
    var sections = modal.querySelectorAll('.heathen-plus-modal__section');
    var cards = root.querySelectorAll('.level[data-tier-identifier]');
    var closeButtons = modal.querySelectorAll('[data-modal-close]');

    function setActiveSection(tierIdentifier) {
      sections.forEach(function (section) {
        var isActive = section.getAttribute('data-tier') === tierIdentifier;
        section.classList.toggle('is-active', isActive);
      });
    }

    function portalModalToBody() {
      if (modal.parentElement !== body) {
        body.appendChild(modal);
      }
    }

    function openModal(tierIdentifier) {
      if (!tierIdentifier) return;
      portalModalToBody();
      setActiveSection(tierIdentifier);
      modal.removeAttribute('hidden');
      modal.classList.add('is-open');
      body.classList.add('heathen-plus-modal-open');
    }

    function closeModal() {
      modal.classList.remove('is-open');
      body.classList.remove('heathen-plus-modal-open');
      modal.setAttribute('hidden', 'hidden');
      sections.forEach(function (section) {
        section.classList.remove('is-active');
      });
    }

    cards.forEach(function (card) {
      var tier = card.getAttribute('data-tier-identifier');
      card.addEventListener('click', function (event) {
        event.preventDefault();
        openModal(tier);
      });
      card.addEventListener('keydown', function (event) {
        if (event.key === 'Enter' || event.key === ' ') {
          event.preventDefault();
          openModal(tier);
        }
      });
    });

    closeButtons.forEach(function (button) {
      button.addEventListener('click', function (event) {
        event.preventDefault();
        closeModal();
      });
    });

    modal.addEventListener('click', function (event) {
      if (event.target === modal) closeModal();
    });

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && modal.classList.contains('is-open')) {
        closeModal();
      }
    });
  }

  function init() {
    var root = document.querySelector('[data-account-dashboard]');
    if (!root) return;
    initFaqAccordion(root);
    initTierModal(root);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
